import { authState, UserPermission } from 'state/auth';
import lodash from 'lodash';

export default function withPermissions<T = any>(permissions: UserPermission[]) {
  const currentUser = authState().user;
  return (val: T, alt?: T): T | null => {
    if (permissions.length > 0) {
      const userPerms = currentUser?.role?.permissions || [];
      if (userPerms.includes('*') || lodash.intersection(permissions, userPerms).length > 0) {
        return val;
      }
      return alt ?? null;
    }
    return val;
  };
}
